import { IntervalScheduler } from '@pp/core/src/utils/IntervalScheduler';

type TickCallback = () => void;

export class GameKeepAliveSchedulerService {
  private scheduler: IntervalScheduler;
  private readonly interval: number;
  private readonly onTick: TickCallback;

  constructor(onTick: TickCallback, interval = 1000) {
    this.interval = interval;
    this.onTick = onTick;

    this.scheduler = new IntervalScheduler({
      interval: this.interval,
      config: { abortOnReSchedule: true },
      onTick: this.handleTick.bind(this),
    });
    this.scheduler.stop();
  }

  private handleTick(): void {
    this.onTick();
  }

  public updateSchedulerState(isGamePaused: boolean, isHighflyerPT: boolean): void {
    if (!isGamePaused && isHighflyerPT) {
      if (!this.scheduler.isRunning) {
        this.scheduler.start();
      }
    } else {
      if (this.scheduler.isRunning) {
        this.scheduler.stop();
      }
    }
  }

  public stop(): void {
    this.scheduler.stop();
  }
}
